<div>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1><i class="fas fa-building"></i> Stream Manager</h1>
        </div>
      </div>
    </div>
  </section>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 table-area"  *ngIf="registerForm">
          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            <div class="card">
              <div class="overlay" *ngIf="scope.wait">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-4">
                    <video #stream class="stream video-js" crossorigin muted preload="auto"></video>
                  </div>
                  <div class="col-8">
                    <div class="form-group">
                      <label for="streamId">Stream ID <span class="required">※</span></label>
                      <input type="text" formControlName="streamId" readonly class="form-control" id="streamId" placeholder="{{scope.stream}}">
                    </div>
                    <div class="form-group">
                      <label for="streamName">Stream Name <span class="required">※</span></label>
                      <input type="text" required formControlName="streamName" class="form-control" id="streamName" placeholder="Stream Name">
                      <div class="error-message"  *ngIf="f.controls.streamName.errors  && f.controls.streamName.errors.required">
                        <small>
                          Stream Nameは必須です。
                        </small>
                      </div>

                    </div>
                    <div class="form-group">
                      <label for="description">Description</label>
                      <textarea class="form-control" id="description" formControlName="description" rows="3" placeholder="Description ..."></textarea>
                    </div>
                    <div class="form-group">
                      <label for="DataRetentionInHours">DataRetentionInHours (保存期間)<span class="required">※</span></label>
                      <input required type="text" formControlName="dataRetentionInHours" class="data-retention-in-hours form-control" id="DataRetentionInHours" placeholder="DataRetentionInHours">
                      <div class="error-message" *ngIf="f.controls.dataRetentionInHours.errors  && f.controls.dataRetentionInHours.errors.required">
                        <small>
                          DataRetentionInHoursは必須です。<br />
                        </small>
                      </div>
                      <div class="error-message" *ngIf="f.controls.dataRetentionInHours.errors  && f.controls.dataRetentionInHours.errors.pattern">
                        <small>
                          半角数字のみで指定してください。
                        </small>
                      </div>
                    </div>
                    <div class="form-group">
                      <label>AI Check</label>
                      <div>
                        <mat-slide-toggle formControlName="aiCheck">{{ f.value.aiCheck }}</mat-slide-toggle>
                      </div>
                    </div>
                    <section class="ai-target-section">
                      <label>AI Target</label>
                      <div>
                        <ng-container formArrayName="aiTargetChecks">
                          <mat-checkbox class="margin" [checked]="aiClasse.value" *ngFor="let aiClasse of this.scope.aiClasses;let i = index" formNameArray="i" (change)="chengeCheckbox(i, aiClasse)">
                            {{ aiClasse.name }}
                          </mat-checkbox>
                        </ng-container>
                      </div>
                      <!-- <div>
                        <mat-checkbox class="margin" formControlName="aiCheckPerson">Person</mat-checkbox>
                        <mat-checkbox class="margin" formControlName="aiCheckBicycle">Bicycle</mat-checkbox>
                        <mat-checkbox class="margin" formControlName="aiCheckMotorbike">Motorbike</mat-checkbox>
                        <mat-checkbox class="margin" formControlName="aiCheckCar">Car</mat-checkbox>
                        <mat-checkbox class="margin" formControlName="aiCheckTrack">Track</mat-checkbox>
                        <mat-checkbox class="margin" formControlName="aiCheckBus">Bus</mat-checkbox>
                      </div> -->
                    </section>
                    <div class="form-group">
                      <label for="dispOrder">DispOrder<span class="required">※</span></label>
                      <input required type="text" formControlName="dispOrder" class="data-retention-in-hours form-control" id="dispOrder" placeholder="DispOrder">
                      <div class="error-message" *ngIf="f.controls.dispOrder.errors  && f.controls.dispOrder.errors.required">
                        <small>
                          DispOrderは必須です。<br />
                        </small>
                      </div>
                      <div class="error-message" *ngIf="f.controls.dispOrder.errors  && f.controls.dataRetentionInHours.errors.pattern">
                        <small>
                          半角数字のみで指定してください。
                        </small>
                      </div>
                    </div>

                  </div>
                  
                </div>
              </div>
              <div class="card-footer">
                <div class="row" *ngIf="scope.stream">
                  <div class="act-buttons offset-4 col-8">
                    <button mat-raised-button type="button" (click)="canceClicked()">cancel</button>
                    <button mat-raised-button type="submit" color="primary">save</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>